module.exports = __webpack_public_path__ + "media/components/ImpactBlock/static/huggreen2-9642db241bf8588ede2c884a6e6feffe.jpg";